

class UserInfoHandler {

    private userInfo : any;

    constructor() {}

    setUserInfo(userInfo : any) {
        this.userInfo = userInfo;
    }

    isAdmin() {
        return this.userInfo.roles[0] == 'admin';
    }

    getRole() {
        return this.userInfo.roles[0];
    }

}

export const userInfoHandler = new UserInfoHandler();


export const userIsAdmin = () => userInfoHandler.isAdmin();

export const userInfo = () => userInfoHandler.getRole();
